import { render, staticRenderFns } from "./AdminDetail.vue?vue&type=template&id=3e0bb49a"
import script from "../../controllers/admin/admin-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/admin/admin-detail.js?vue&type=script&lang=js&external"
import style0 from "./AdminDetail.vue?vue&type=style&index=0&id=3e0bb49a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports